module.exports = __webpack_public_path__ + "static/media/Work-Sans-regular.66d86df2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Work-Sans-regular/Work-Sans-regular.woff2
// module id = 419
// module chunks = 0